import { escapeHtml } from "../util/html";

/** 互动页「古典名画对对配」微信小程序说明（纯文案，不含 HTML） */
export const DESC_PAINTING_MATCH_MINI =
  "一款艺术工具类小程序，通过行走配对驻足观赏等形式，帮助用户学习世界名画知识。包含世界著名绘画大师的 60 余幅经典作品。8 关难度适中，寓教于乐，适合全年龄段用户体验古典艺术的魅力。所有名画均为公有领域作品，无版权问题。";

/** 互动页「古典音乐线条」微信小程序说明（纯文案，不含 HTML） */
export const DESC_MUSIC_LINES_MINI =
  "古典音乐线条是一款节奏跑酷小程序：五线谱号沿着音乐节奏轨道前进，用户通过换档与跳跃越过断档，在古典乐曲播放时间内抵达终点即可过关。操作单点即可完成，无对战、无内购诱导，适合碎片时间放松，兼具古典乐查询欣赏与手眼协调趣味。";

export function wechatOpenButtonHtml(openLink: string): string {
  const u = openLink.trim();
  if (!u) {
    return `<p class="section-sub" style="margin-top:1rem">请在微信中搜索并打开对应小程序进行游玩。</p>`;
  }
  return `<p class="wechat-mini-cta" style="margin-top:1rem">
    <a class="pill-btn pill-btn-link" href="${escapeHtml(u)}" target="_blank" rel="noopener noreferrer">打开微信小程序</a>
  </p>`;
}
